import React from 'react';
import barchart from 'assets/images/charts/barchart.svg';
import analyticBarChart from 'assets/images/charts/analytic-barchart.svg';
import guage from 'assets/images/charts/icon_gauge.svg';
import icnText from 'assets/images/charts/icn-text-panel.svg';
import icnStat from 'assets/images/charts/icn-singlestat-panel.svg';
import icnImage from 'assets/images/charts/icon_image.svg';
import icnLine from 'assets/images/charts/icn-line.svg';
import icnLinkDb from 'assets/images/charts/icn-link-db.svg';
import icnTable from 'assets/images/charts/icn-table.svg';
import icnIndicator from 'assets/images/charts/icn-indicator.svg';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';

// export const PANEL_VALUES = {
//     analyticsBarChart: 'analyticsbachart',
//     barchart: 'barchart',
//     guage: 'guage',
//     piechart: 'piechart',
//     text: 'text',
//     stat: 'stat',
//     linechart: 'linechart',
//     image: 'image',
//     area: 'area',
//     linkButton: 'linkButton',
//     maintenance: 'maintenance',
//     indicator: 'indicator',
//     table: 'table',
//     date_time: 'date_time',
//     alarm_widget: 'alarm_widget',
//     groups:'groups,'

// };

// export const isMaintenanceWidget = type => type === PANEL_VALUES.maintenance;

// export const isAlarmWidget = type => type === PANEL_VALUES.alarm_widget;

// export const isAnalyticsWidget = type =>
//     type === PANEL_VALUES.analyticsBarChart;

// const DataSourceWidget = [
//     PANEL_VALUES.analyticsBarChart,
//     PANEL_VALUES.indicator,
// ];

// export const isDataSourceWidget = type => DataSourceWidget.includes(type);

// const SingleTagWidgets = [
//     PANEL_VALUES.guage,
//     PANEL_VALUES.stat,
//     PANEL_VALUES.indicator,
// ];

// export const isMultiTagAllowed = type => !SingleTagWidgets.includes(type);

// export const PANEL_TYPES = [
//     {
//         value: PANEL_VALUES.alarm_widget,
//         label: 'Alarm',
//         mIcon: () => <AccessAlarmIcon />,
//         subtitle: 'Alarm panel for Advait',
//         default: null,
//     },
//     {
//         value: PANEL_VALUES.analyticsBarChart,
//         label: 'Analytics Chart',
//         icon: analyticBarChart,
//         subtitle: 'Analytical Bar and Line charts of Advait',
//         default: '1',
//     },
//     {
//         value: PANEL_VALUES.barchart,
//         label: 'Bar Chart',
//         icon: barchart,
//         subtitle: 'Categorical charts for Advait',
//         default: '1',
//     },
//     {
//         value: PANEL_VALUES.linkButton,
//         label: 'Button',
//         icon: icnLinkDb,
//         subtitle: 'Dashboard Link',
//         default: null,
//     },
//     {
//         value: PANEL_VALUES.guage,
//         label: 'Guage',
//         icon: guage,
//         subtitle: 'Standard guage visualization',
//         default: 'Default',
//     },
//     {
//         value: PANEL_VALUES.indicator,
//         label: 'Indicator',
//         icon: icnIndicator,
//         subtitle: 'Indicator based on live value of selected tag',
//         default: '1',
//     },
//     {
//         value: PANEL_VALUES.linechart,
//         label: 'Line Chart',
//         icon: icnLine,
//         subtitle: 'Line Chart panel for Advait',
//         default: null,
//     },
//     // {
//     //   value: PANEL_VALUES.area,
//     //   label: 'Area Chart',
//     //   icon: icnArea,
//     //   subtitle: 'Area Chart panel for Advait',
//     //   default: null,
//     // },
//     // {
//     //   value: PANEL_VALUES.piechart,
//     //   label: 'Pie Chart',
//     //   icon: piechart,
//     //   subtitle: 'Piechart panel for Advait',
//     //   default: null,
//     // },

//     {
//         value: PANEL_VALUES.image,
//         label: 'Image',
//         icon: icnImage,
//         subtitle: 'Image panel for Advait',
//         default: null,
//     },
//     {
//         value: PANEL_VALUES.maintenance,
//         label: 'Maintenance',
//         icon: icnTable,
//         subtitle: 'Maintenance Schedule Widget',
//         default: null,
//     },
//     {
//         value: PANEL_VALUES.stat,
//         label: 'Stat',
//         icon: icnStat,
//         subtitle: 'Stat panel for Advait',
//         default: null,
//     },
//     {
//         value: PANEL_VALUES.text,
//         label: 'Text',
//         icon: icnText,
//         subtitle: 'Text panel for Advait',
//         default: null,
//     },
//     {
//         value: PANEL_VALUES.table,
//         label: 'Tag Table',
//         icon: icnTable,
//         subtitle: 'Tag Table Widget fro Advait',
//         default: null,
//     },
//     {
//         value: PANEL_VALUES.date_time,
//         label: 'Date Time',
//         mIcon: () => <EventAvailableIcon />,
//         subtitle: 'Date Time panel for Advait',
//         default: null,
//     },
// ];

// const NO_DATA_SOURCE_PANELS = [
//     PANEL_VALUES.text,
//     PANEL_VALUES.image,
//     PANEL_VALUES.linkButton,
//     PANEL_VALUES.analyticsBarChart,
//     PANEL_VALUES.maintenance,
//     PANEL_VALUES.date_time,
//     PANEL_VALUES.alarm_widget,
// ];

// export const isDataSourceRequired = panelType =>
//     !NO_DATA_SOURCE_PANELS.includes(panelType);

// const NO_TITLE_PANELS = [
//     PANEL_VALUES.text,
//     PANEL_VALUES.image,
//     PANEL_VALUES.linkButton,
//     PANEL_VALUES.date_time,
// ];

// export const shouldShowTitleBar = panelType =>
//     !NO_TITLE_PANELS.includes(panelType);

// export const ARITHMETIC_OPERATIONS = [
//     {
//         value: '+',
//         label: 'Add',
//     },
//     {
//         value: '-',
//         label: 'Subtract',
//     },
//     {
//         value: '/',
//         label: 'Divide',
//     },
//     {
//         value: '*',
//         label: 'Multiply',
//     },
//     {
//         value: 'none',
//         label: 'None',
//     },
// ];

export function adjustTextFontsize(f, domElements = []) {
    domElements.forEach(element => {
        const s = element?.offsetWidth;
        const h = element?.offsetHeight;
        const fs = h <= 40 ? (s / 2) * f : s * f;
        if (element) {
            // eslint-disable-next-line no-param-reassign
            element.style.fontSize = `${fs}%`;
        }
    });
}

export const layoutBreakpoints = ['lg', 'md', 'sm', 'xs', 'xxs'];

export const BREAKPOINTS_WITH_WIDTH = {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 2,
};

export const getLayout = panels => {
    const newLayouts = {};
    panels.forEach(panel => {
        const { config } = panel;
        if ('layouts' in config) {
            const { layouts } = config;
            layoutBreakpoints.forEach(breakpoint => {
                if (breakpoint in layouts) {
                    if (breakpoint in newLayouts) {
                        newLayouts[breakpoint].push(layouts[breakpoint]);
                    } else {
                        newLayouts[breakpoint] = [layouts[breakpoint]];
                    }
                }
            });
        }
    });
    return newLayouts;
};

export const getBreakpoint = (width = 0) => {
    let breakpoint = 'xxs';
    if (width >= BREAKPOINTS_WITH_WIDTH.lg) {
        breakpoint = 'lg';
    }
    if (width >= BREAKPOINTS_WITH_WIDTH.md) {
        breakpoint = 'md';
    }
    if (width >= BREAKPOINTS_WITH_WIDTH.sm) {
        breakpoint = 'sm';
    }
    if (width >= BREAKPOINTS_WITH_WIDTH.xs) {
        breakpoint = 'lg';
    }
    return breakpoint;
};

export const hasContentData = content => Boolean(Object.keys(content).length);

export const isBarChart = type => type === PANEL_VALUES.barchart;

export const isTableWidget = type => type === PANEL_VALUES.table;

export const getOverflowValue = type => {
    if (type === PANEL_VALUES.guage) {
        return 'hidden';
    }
    return 'auto';
};

export const isGLG = type => type === 'GLG';
